import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-0"}],["path",{"d":"M15 6a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M15 18a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-2"}],["path",{"d":"M8.7 10.7l6.6 -3.4","key":"svg-3"}],["path",{"d":"M8.7 13.3l6.6 3.4","key":"svg-4"}]]

const IconShare = createReactComponent('outline', 'share', 'Share', __iconNode);

export default IconShare;